import { useState } from 'react'
import { Link } from 'react-router-dom'
import { 
  SignedIn, 
  SignedOut, 
  UserButton, 
  SignInButton, 
  SignUpButton 
} from '@clerk/clerk-react'
import './layout.css'
import Logo from '../assets/logo/logo.png'

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false)

  const toggleMenu = () => setMenuOpen(!menuOpen)
  const closeMenu = () => setMenuOpen(false)

  return (
    <header className="navbar">
      <Link to="/" className="logo">
        <img src={Logo} alt="logo" />
      </Link>

      <nav className="links">
        <Link to="/">Shop</Link>
        <Link to="/tailor">Tailor</Link>
        <Link to="/design">Design</Link>
        <Link to="/opportunities">Opportunities</Link>
      </nav>

      <div className="nav-right">
        <SignedIn>
          <UserButton afterSignOutUrl="/" />
        </SignedIn>
        
        <SignedOut>
          <div className="auth-buttons">
            <SignInButton mode="modal">
              <button className="signin-btn">Sign In</button>
            </SignInButton>
            <SignUpButton mode="modal">
              <button className="signup-btn">Sign Up</button>
            </SignUpButton>
          </div>
        </SignedOut>
      </div>

      <button
        className="menu-btn"
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
      </button>

      <nav className={`dropdown-menu ${menuOpen ? 'show' : ''}`}>
        <Link to="/" onClick={closeMenu}>Shop</Link>
        <Link to="/tailor" onClick={closeMenu}>Tailor</Link>
        <Link to="/design" onClick={closeMenu}>Design</Link>
        <Link to="/opportunities" onClick={closeMenu}>Opportunities</Link>
        
        <SignedIn>
          <div className="dropdown-auth">
            <UserButton afterSignOutUrl="/" />
          </div>
        </SignedIn>
        
        <SignedOut>
          <div className="dropdown-auth-buttons">
            <SignInButton mode="modal">
              <button className="dropdown-signin" onClick={closeMenu}>Sign In</button>
            </SignInButton>
            <SignUpButton mode="modal">
              <button className="dropdown-signup" onClick={closeMenu}>Sign Up</button>
            </SignUpButton>
          </div>
        </SignedOut>
      </nav>
    </header>
  )
}

export default Navbar